import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('wyzcon_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-refresh on 401
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    if (error.response?.status === 401) {
      const refresh = localStorage.getItem('wyzcon_refresh');
      if (refresh) {
        try {
          const { data } = await axios.post(`${API_BASE}/auth/token/refresh/`, { refresh });
          localStorage.setItem('wyzcon_token', data.access);
          error.config.headers.Authorization = `Bearer ${data.access}`;
          return api(error.config);
        } catch {
          localStorage.removeItem('wyzcon_token');
          localStorage.removeItem('wyzcon_refresh');
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

// Schools
export const getSchools = () => api.get('/schools/');
export const getSchool = (id) => api.get(`/schools/${id}/`);
export const getSchoolOverview = () => api.get('/schools/overview/');
export const deploySchool = (data) => api.post('/schools/deploy/', data);
export const getSchoolLogs = (id) => api.get(`/schools/${id}/logs/`);

// Containers
export const getContainerStatus = (id) => api.get(`/containers/${id}/status/`);
export const restartContainers = (id, service) => api.post(`/containers/${id}/restart/`, { service });
export const stopContainers = (id) => api.post(`/containers/${id}/stop/`);
export const startContainers = (id) => api.post(`/containers/${id}/start/`);
export const getContainerLogs = (id, service, lines) =>
  api.get(`/containers/${id}/logs/`, { params: { service, lines } });
export const getSystemStats = () => api.get('/containers/system/stats/');

// Backups
export const getBackups = (schoolId) => api.get('/backups/', { params: { school_id: schoolId } });
export const triggerBackup = (id) => api.post(`/backups/${id}/trigger/`);
export const triggerAllBackups = () => api.post('/backups/trigger-all/');

// Billing
export const getBillingOverview = () => api.get('/billing/overview/');
export const getInvoices = (params) => api.get('/billing/', { params });
export const createInvoice = (data) => api.post('/billing/create/', data);
export const updateInvoice = (id, data) => api.patch(`/billing/${id}/update/`, data);
export const generateMonthlyInvoices = () => api.post('/billing/generate-monthly/');

// Domains
export const getDomains = () => api.get('/domains/');
export const createDomain = (data) => api.post('/domains/create/', data);
export const deleteDomain = (id) => api.delete(`/domains/${id}/delete/`);

// Auth
export const login = (username, password) =>
  axios.post(`${API_BASE}/auth/token/`, { username, password });

export default api;
